<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showProduct") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Product Images -->
          <div class="col-12 mb-4">
            <div class="preview-container text-center my-3">
              <img
                :src="data.image.path"
                alt="Product Image"
                v-if="data.image.path"
                class="main-product-image"
                @click="showImageModal(data.image.path)"
              />
            </div>
            <!-- Additional Images -->
            <div
              class="additional-images d-flex flex-wrap gap-2 justify-center"
              v-if="data.images && data.images.length"
            >
              <img
                v-for="image in data.images"
                :key="image.id"
                :src="image.url"
                alt="Product Image"
                class="additional-image"
                @click="showImageModal(image.url)"
              />
            </div>
          </div>
          <!-- End:: Product Images -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.codename')"
            v-model.trim="data.name"
            disabled
          />

          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.brand')"
            v-model.trim="data.brand.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.main_category')"
            v-model.trim="data.main_category"
            disabled
          />
          <!-- End:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.sub_section')"
            v-model.trim="data.sub_category"
            disabled
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.price')"
            v-model.trim="data.price"
            disabled
          />
          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('TABLES.Workplaces.date')"
            v-model.trim="data.created_at"
            disabled
          />

          <!-- Start:: Package Details Section -->
          <div class="col-12 my-4">
            <h5 class="text-primary mb-3">
              {{ $t("PLACEHOLDERS.package_details") }}
            </h5>
          </div>

          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.number_of_units')"
            v-model.trim="data.number_of_units"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.unit_weight')"
            v-model.trim="data.unit_weight"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.measurement_unit')"
            v-model.trim="data.measurement_unit"
            disabled
          />
          <!-- End:: Package Details Section -->

          <!-- Start:: Offer Details Section -->
          <div class="col-12 my-4" v-if="data.active_offer">
            <h5 class="text-success mb-3">
              {{ $t("PLACEHOLDERS.offer_details") }}
            </h5>
          </div>

          <base-input
            v-if="data.active_offer"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discount_percentage')"
            :value="data.active_offer.discount + '%'"
            disabled
          />

          <base-input
            v-if="data.active_offer"
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.discounted_price')"
            v-model.trim="data.active_offer.price_after_discount"
            disabled
          />

          <base-input
            v-if="data.active_offer"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.remaining_days')"
            :value="
              data.active_offer.number_of_remaining_days +
              ' ' +
              $t('PLACEHOLDERS.days')
            "
            disabled
          />
          <!-- End:: Offer Details Section -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Image Modal -->
    <v-dialog v-model="dialogImage" max-width="800">
      <v-card>
        <v-card-text class="text-center">
          <img
            :src="selectedImage"
            alt="Product Image"
            style="max-width: 100%; max-height: 70vh"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogImage = false">{{
            $t("BUTTONS.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowProduct",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        

},
        images: [],
        name: null,
        nameEn: null,
        main_category: null,
        sub_category: null,
        price: null,
        brand: null,
        count_order: null,
        created_at: null,
        active: null,
        number_of_units: null,
        unit_weight: null,
        measurement_unit: null,
        active_offer: null,
      },
      // End:: Data Collection To Send

      // Start:: Dialog Control
      dialogImage: false,
      selectedImage: null,
      // End:: Dialog Control
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Start:: Show Image Modal
    showImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.dialogImage = true;
    },
    // End:: Show Image Modal

    // start show data
    async showProduct() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `products/${this.$route.params.id}`,
        });
        this.data.image.path = res.data.data.data.main_image;
        this.data.images = res.data.data.data.images || [];
        this.data.name = res.data.data.data.name;
        this.data.main_category = res.data.data.data.sub_category.category.name;
        this.data.sub_category = res.data.data.data.sub_category.name;
        this.data.price = res.data.data.data.price;
        this.data.brand = res.data.data.data.brand;
        this.data.count_order = res.data.data.data.count_order;
        this.data.created_at = res.data.data.data.created_at;
        this.data.active = res.data.data.data.is_active;

        // Set package details
        this.data.number_of_units = res.data.data.data.number_of_units;
        this.data.unit_weight = res.data.data.data.unit_weight;
        this.data.measurement_unit = res.data.data.data.measurement_unit;

        // Set offer details
        this.data.active_offer = res.data.data.data.active_offer;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },

  created() {
    // Start:: Fire Methods
    this.showProduct();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.main-product-image {
  max-width: 100%;
  max-height: 300px;
  border: 2px solid #3eb6d4;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.main-product-image:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 12px rgba(61, 95, 255, 0.3);
}

.additional-images {
  margin-top: 20px;
}

.additional-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.additional-image:hover {
  border-color: #3eb6d4;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(61, 95, 255, 0.3);
}

.gap-2 {
  gap: 8px;
}
</style>
